export const locale = {
    lang: 'vn',
    data: {
        'CHANGE_PASSWORD_VIEW': {
            'TITLE': 'Thay đổi mật khẩu',
            'OLD_PASSWORD': 'Mật khẩu hiện tại',
            'NEW_PASSWORD': 'Mật khẩu mới',
            'CONFIRM_NEW_PASSWORD': 'Nhập lại mật khẩu mới',
            'ERROR_CODES':
                {
                    'POSER-REQ-014': 'Mật khẩu hiện tại không chính xác.\nXin vui lòng thử lại.',
                    'OTHER': 'Lỗi. Xin vui lòng thử lại.',
                },
            'SUGGESTION' : {
                'LENGTH': 'Mật khẩu mới cần có tối thiểu 6 ký tự và không bao gồm khoảng trắng.',
                'SECURITY': 'Để tăng tính bảo mật cho tài khoản, bạn nên sử dụng ít nhất 1 chữ cái in hoa, 1 chữ số, hoặc 1 ký tự đặc biệt.'
            },
            'VALIDATION' : {
                'OLD_PASSWORD_REQUIRED': 'Mật khẩu hiện tại là bắt buộc',
                'NEW_PASSWORD_REQUIRED': 'Mật khẩu mới là bắt buộc',
                'NEW_PASSWORD_MINLENGTH': 'Mật khẩu mới cần ít nhất 6 ký tự',
                'NEW_PASSWORD_NOT_SAME': 'Mật khẩu mới không được phép trùng mật khẩu hiện tại',
                'NEW_PASSWORD_WHITESPACE': 'Mật khẩu mới không được phép có khoảng trắng',
                'CONFIRM_PASSWORD_REQUIRED': 'Nhập lại mật khẩu mới là bắt buộc',
                'CONFIRM_PASSWORD_NOT_SAME': 'Mật khẩu nhập lại chưa trùng khớp',
            },
            'ACTION': {
                'SAVE_CHANGE': 'LƯU THAY ĐỔI',
                'CLOSE':  'ĐÓNG',
            }
        },
        'CHANGE_PASSWORD_SUCCESS': {
            'CLOSE': 'ĐÓNG',
            'MESSAGE': 'Mật khẩu của bạn đã được thay đổi thành công. Vui lòng đăng nhập lại bằng mật khẩu mới.',
            'TITLE': 'Đổi mật khẩu thành công!'
        }
    }
};
